'use client';
import Link from 'next/link';
import React, { useState } from 'react';
import { FaAngleRight } from 'react-icons/fa6';

const MobileMenuItem = ({ item }: { item: any }) => {
  const [open, setOpen] = useState(false);

  const hasChildren = item.children && item.children.length > 0;

  const closeMobileMenu = () => {
    const menu = document.querySelector('.menu-mobile') as HTMLElement;
    const overlay = document.querySelector('.header__overlay') as HTMLElement;

    if (menu && overlay) {
      menu.classList.remove('active');
      overlay.classList.remove('active');
    }
  };

  return (
    <li className={hasChildren ? 'menu-item-has-children' : ''}>
      <div
        onClick={() => setOpen(!open)}
        className="d-flex justify-content-between align-items-center pe-3"
      >
        <Link
          href={item.href || `/shop?category=${item.slug}`}
          onClick={() => {
            if (!hasChildren) closeMobileMenu();
          }}
        >
          {item?.title || item?.name}
        </Link>
        {hasChildren && (
          <div style={{ cursor: 'pointer', marginLeft: '8px' }}>
            <FaAngleRight
              className={`transition-transform duration-300 ${open ? 'rotate-90' : ''}`}
            />
          </div>
        )}
      </div>

      {hasChildren && open && (
        <ul className="menu-section" style={{ paddingLeft: '0.5rem' }}>
          {item.children.map((child: any, index: number) => (
            <MobileMenuItem item={child} key={index} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MobileMenuItem;
